<template>
    <vTransactionLogisticsComponent :postList="postList" v-if="flag"></vTransactionLogisticsComponent>
</template>
<script>
import vTransactionLogisticsComponent from '../../listComponent/basicdata/transactionLogistics/transactionLogisticsComponent.vue';
export default {
    name: 'transactionLogistics',
    components: {
        vTransactionLogisticsComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                is_show_search: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>